import React, { MouseEventHandler, PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import cx from "classnames";
import "./styles.scss";

interface Props {
  to?: string;
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  className?: string;
  isText?: boolean;
  colorEnabled?: boolean;
}

const ProfileButton = ({
  to,
  onClick,
  className,
  isText,
  children,
  colorEnabled = true,
}: PropsWithChildren<Props>) => {
  const classes = cx(
    "profile-button",
    {
      "profile-button--text": isText,
      "profile-button--colored": colorEnabled,
    },
    className
  );

  if (to) {
    return (
      <Link className={classes} to={to}>
        {children}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={classes}>
      {children}
    </button>
  );
};

export default ProfileButton;
